var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-create-header"},[_c('h1',[_c('span',{staticClass:"circle-step"},[_vm._v(_vm._s(_vm.addLearnerStep))]),_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("tooltip")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }